import React, { useEffect, useState } from "react";
import { BrowserRouter, useLocation } from "react-router-dom";
import AppRoutes from "./routes";
import { Footer } from "../components/footer/footer.component";
import { Header } from "../components/header/header.component";
import NavBar from "../components/nav";
import SideMenuDrawer from "../components/sideMenuDrawer";
import { PageContainer } from "../components/pageContainer";
import { ContentOnlyLogo } from "../components/contentOnlyLogo";
import "pure-react-carousel/dist/react-carousel.es.css";
import FabButtonComponent from "components/fab";
import { useAppController } from "./context/app-controller";
import { useAppState } from "main/context/app-context";
import { Grid, CircularProgress, Typography } from "@material-ui/core";

const AppContent: React.FC = () => {
  const location = useLocation();
  const [isShowingNavMenu, setIsShowingNavMenu] = React.useState<boolean>(false);

  // Detectar querystring onlyContent
  const searchParams = new URLSearchParams(location.search);
  const isOnlyContent = searchParams.has('onlyContent');
  const showFullLayout = !isOnlyContent;

  const handleShowMenu = () => {
    setIsShowingNavMenu(true);
  };

  return (
    <>
      {showFullLayout && <Header showNavMenu={handleShowMenu} />}
      {showFullLayout && <NavBar />}
      {showFullLayout && isShowingNavMenu && (
        <SideMenuDrawer onClose={() => setIsShowingNavMenu(false)} />
      )}

      {isOnlyContent && <ContentOnlyLogo />}

      <div id="content">
        <PageContainer>
          <AppRoutes />
          {showFullLayout && <FabButtonComponent />}
        </PageContainer>
      </div>

      {showFullLayout && <Footer />}
    </>
  );
};

function App() {
  const { applicationData } = useAppState();
  const [initialLoading, setInitialLoading] = useState(true);
  const { getApplicationData, getMenus, getHomeNews, getHomeLinkServices, getHomeBanners } = useAppController();

  const handleKeydown = (event: any) => {
    if (event.altKey) {
      switch (event.code) {
        case "Digit1": // Alt + 1
          document.getElementById("content")?.scrollIntoView({ behavior: "smooth" });
          break;
        case "Digit2": // Alt + 2
          document.getElementById("menu")?.scrollIntoView({ behavior: "smooth" });
          break;
        case "Digit3": // Alt + 3
          document.getElementById("search")?.scrollIntoView({ behavior: "smooth" });
          break;
        case "Digit4": // Alt + 4
          document.getElementById("footer")?.scrollIntoView({ behavior: "smooth" });
          break;
        default:
          break;
      }
    }
  };

  const loadingComponent = (<Grid container
    style={{
      height: '100vh'
    }}
    spacing={0}
    direction="column"
    alignItems="center"
    justifyContent="center"
  >
    <CircularProgress color="primary" />
    <Typography>carregando...</Typography>

  </Grid>);

  useEffect(() => {

    const onInit = async () => {

    var applicationData=  await getApplicationData();

    // Buscar menus após obter application data
    if (applicationData?.entity?.id) {
        await getMenus(applicationData.entity.id);
    }

    // Carregar dados da home para evitar recarregar posteriormente
    await Promise.all([
        getHomeNews(4),
        getHomeLinkServices(12),
        getHomeBanners()
    ]);

      setInitialLoading(false);

    };

    if (applicationData === undefined) {
      onInit();
    }
    window.addEventListener("keydown", handleKeydown);
    return () => {
      window.removeEventListener("keydown", handleKeydown);
    };
  }, []);

  useEffect(() => {
    document.title = `Diário Oficial da ${applicationData?.entity?.corporateName}`;
  }, [applicationData]);

  return (
    <>
      {
        initialLoading ? loadingComponent :
          <React.Fragment>
            <BrowserRouter>
              <AppContent />
            </BrowserRouter>
          </React.Fragment>
      }
    </>
  );
}

export default App;
